// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DatavizRouteImport } from './routes/dataviz'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as ParcoursRouteImport } from './routes/parcours'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as ProjetsRouteImport } from './routes/projets'
import { Route as RedactionIndexRouteImport } from './routes/redaction/index'
import { Route as RedactionDashboardRouteImport } from './routes/redaction/dashboard'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DatavizRoute = DatavizRouteImport.update({
            id: '/dataviz',path: '/dataviz',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const ParcoursRoute = ParcoursRouteImport.update({
            id: '/parcours',path: '/parcours',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const ProjetsRoute = ProjetsRouteImport.update({
            id: '/projets',path: '/projets',getParentRoute: () => rootRouteImport
          })
const RedactionIndexRoute = RedactionIndexRouteImport.update({
            id: '/redaction/',path: '/redaction/',getParentRoute: () => rootRouteImport
          })
const RedactionDashboardRoute = RedactionDashboardRouteImport.update({
            id: '/redaction/dashboard',path: '/redaction/dashboard',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ConfidentialiteRoute: ConfidentialiteRoute,ContactRoute: ContactRoute,DatavizRoute: DatavizRoute,MentionsLegalesRoute: MentionsLegalesRoute,ParcoursRoute: ParcoursRoute,PortfolioRoute: PortfolioRoute,ProjetsRoute: ProjetsRoute,RedactionDashboardRoute: RedactionDashboardRoute,RedactionIndexRoute: RedactionIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)